import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24.485 24.485c4.687-4.686 4.687-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0L4.978 10.05l.001-2.586-.007-.116a1 1 0 0 0-1.993.117v5l.007.116.009.059.027.114.026.077.058.121.06.094q.047.066.106.126l.09.08.029.021.12.075.09.042.07.026.116.03.114.015 5.078.003.117-.006a1 1 0 0 0 .883-.994l-.007-.116a1 1 0 0 0-.993-.884H6.393L8.93 8.929l.215-.21c3.92-3.694 10.093-3.624 13.927.21 3.905 3.905 3.905 10.237 0 14.142s-10.237 3.905-14.142 0a1 1 0 1 0-1.414 1.414c4.686 4.687 12.284 4.687 16.97 0M16.993 9.883A1 1 0 0 0 15 10v6.02l.007.097.012.077.018.078.036.103.034.075.042.075.065.093.092.102.069.06.076.056 5.245 3.03.104.053a1 1 0 0 0 .896-1.785L17 15.422 17 10z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconClockCounterClockwise = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconClockCounterClockwise);
export default Memo;
